import { useAdminsStore } from 'views/store/useAdminsStore';
import { EAdminRole } from 'views/types/admins';

/**
 * Custom hook to check if the current admin is a Super Admin
 * @returns boolean indicating if current admin is Super Admin
 */
export const useIsSuperAdmin = (): boolean => {
  const { currentAdmin } = useAdminsStore();

  return currentAdmin?.role === EAdminRole.SUPER_ADMIN;
};
